<template>
    <MainLayout>
        <section class="hero-block">
            <div class="container hero-block__container">
                <div class="hero-block__text">
                    <h1 class="hero-block__title">Contact us</h1>
                    <div class="hero-block__description">
                        If you have a question about our features, datasets,
                        usage, or want a demo, or anything else, our team is
                        ready to help.
                    </div>
                </div>
                <div class="hero-block__inner hero-block-inner">
                    <div class="hero-block-inner__image">
                        <img
                            src="../assets/images/circle.svg"
                            alt="Dataset for your project"
                        />
                    </div>
                    <form
                        class="hero-block-inner__form form-contact"
                        @submit.prevent="submit"
                    >
                        <v-text-field
                            v-model="model.email"
                            v-validate="{ required: true, email: true }"
                            name="email"
                            prepend-inner-icon="mail"
                            :label="$t('fields.email')"
                            type="email"
                            :data-vv-as="$t('fields.email')"
                            :error-messages="errors.collect('email')"
                            outlined
                        />
                        <v-text-field
                            v-model="model.name"
                            v-validate="{ required: true }"
                            prepend-inner-icon="person"
                            name="name"
                            :label="$t('fields.name')"
                            type="name"
                            :data-vv-as="$t('fields.name')"
                            :error-messages="errors.collect('name')"
                            outlined
                        />
                        <v-textarea
                            v-model="model.message"
                            v-validate="'required'"
                            name="message"
                            :label="$t('fields.message')"
                            :data-vv-as="$t('fields.message')"
                            :error-messages="errors.collect('message')"
                            outlined
                        />

                        <div class="form-contact__row form-row">
                            <button type="submit" class="form-row__submit">
                                Send
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </MainLayout>
</template>

<script>
    import { general } from '~api';
    import { Handler } from '~services';
    import MainLayout from '../layouts/MainLayout.vue';

    export default {
        $_veeValidate: {
            validator: 'new',
        },
        components: {
            MainLayout,
        },
        data() {
            return {
                model: {
                    email: '',
                    message: '',
                    name: '',
                },
                isLoading: false,
                sitekey: '6Ld07wAVAAAAAOByK2gQhD8OGuAAS4vxWU-EX61l',
            };
        },
        methods: {
            /**
             * Create user and redirect to confirmation registration page
             */
            async submit(result) {
                if (!result) return;
                this.isLoading = true;

                const validation = await this.$validator.validateAll();
                if (!validation) return;

                const data = new FormData();
                data.append('email', this.model.email);
                data.append('name', this.model.name);
                data.append('message', this.model.message);

                const resp = await general.contact(data);

                Handler.handleResponse(resp, resp.data, resp.data);

                this.isLoading = false;
            },
        },
    };
</script>

<style scoped lang="stylus">
    @import '../assets/styles/pages/contact';
</style>
